export enum ApplianceDetailsFormField {
  ApplianceCategory = 'applianceCategory',
  ApplianceCode = 'applianceCode',
}
